import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: require('../views/BlueBg.vue').default,
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "landing" */ '../views/Home.vue')
      },
      {
        path: '/login',
        component: () => import(/* webpackChunkName: "landing" */ '../views/Login.vue')
      },
      {
        path: '/register',
        component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue')
      },

      {
        path: '/lab',
        component: () => import(/* webpackChunkName: "lab" */ '../views/Lab.vue')
      },
      {
        path: '/contact',
        component: () => import(/* webpackChunkName: "pages" */ '../views/Contact.vue')
      },
      {
        path: '/team',
        component: () => import(/* webpackChunkName: "pages" */ '../views/Team.vue')
      },
      {
        path: '/about',
        component: () => import(/* webpackChunkName: "pages" */ '../views/About.vue')
      }
    ]
  },

  // GL
  {
    path: '/studio',
    component: () => import(/* webpackChunkName: "about" */ '../views/JellyStudio.vue')
  },
  {
    path: '/studio-lab',
    component: () => import(/* webpackChunkName: "about" */ '../views/JellyStudioLab.vue')
  },
  {
    path: '/flower',
    component: () => import(/* webpackChunkName: "about" */ '../views/JellyFlower.vue')
  },
  {
    path: '/love',
    redirect: '/jelly-hand'
  },

  {
    path: '/jelly-hand',
    component: () => import(/* webpackChunkName: "about" */ '../views/FollowJellyFish.vue')
  },
  {
    path: '/mountain',
    component: () => import(/* webpackChunkName: "about" */ '../views/Mountain.vue')
  },

  {
    path: '/emoji',
    component: () => import(/* webpackChunkName: "about" */ '../views/EmojiMatrix.vue')
  },
  {
    path: '/exp',
    component: () => import(/* webpackChunkName: "Exp" */ '../views/Exp.vue')
  },
  {
    path: '/audio',
    component: () => import(/* webpackChunkName: "Exp" */ '../views/AudioVisualiser.vue')
  },
  {
    path: '/GSRibbon',
    component: () => import(/* webpackChunkName: "Exp" */ '../views/GSRibbon.vue')
  },
  {
    path: '/GSTube',
    component: () => import(/* webpackChunkName: "Exp" */ '../views/GSTube.vue')
  },
  {
    path: '/AudioVisualiserSphere',
    component: () => import(/* webpackChunkName: "Exp" */ '../views/AudioVisualiserSphere.vue')
  }
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
